export default "__VITE_ASSET__Brg4plxx__"